import { agent } from './utils.js';
import { onCLS, onFID, onLCP, onTTFB, onFCP, onINP } from 'web-vitals';

function gaEventPush(event) {
    if(window?.queuedDataLayer){
       queuedDataLayer.push(event)
    } else {
        dataLayer?.push(event)
    }
}

function populateToAnalytics(performanceMetrics) {
    // eslint-disable-next-line
    gaEventPush({
        event: 'timing event',
        effect: 'timing event loaded',
        category: {
            primaryCategory: 'ux',
            subCategory: 'timing',
        },
        attributes: {
            ...performanceMetrics,
        },
    });
}

function routerTrackEvent(history) {
    history.listen((location) => {
        agent('trackEvent', { type: 'pageView', path: location.pathname });
        if (typeof window !== 'undefined' && window.vitals) {
            window.vitals = {};
        }
    });
}

function reportWebVitalsMetrics() {
    onCLS(sendToAnalytics);
    onFID(sendToAnalytics);
    onFCP(sendToAnalytics);
    onLCP(sendToAnalytics);
    onTTFB(sendToAnalytics);
    onINP(sendToAnalytics);
}

function sendToAnalytics(metrics) {
    const { name, delta } = metrics;
    const duration = Math.round(name === 'CLS' ? delta * 1000 : delta);
    exposeMetricToWindow(name, duration);
    populateToAnalytics({ [name]: duration });
}

function exposeMetricToWindow(name, value) {
    if (typeof window !== 'undefined') {
        window.vitals ? (window.vitals[name] = value) : (window.vitals = { [name]: value });
    }
}

export { routerTrackEvent, reportWebVitalsMetrics, exposeMetricToWindow, populateToAnalytics, gaEventPush };
